import { render, staticRenderFns } from "./Dwaya.vue?vue&type=template&id=6d03534a&"
import script from "./Dwaya.vue?vue&type=script&lang=js&"
export * from "./Dwaya.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports